import React, { useState } from 'react';
import './faq.scss';
import Navbar from '../Navbar/navbar';
import Footer from '../Footer/footer';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        {question}
        <span className="icon">{isOpen ? '-' : '+'}</span>
      </button>
      {isOpen && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const FAQSection = ({ title, items }) => (
  <div className="faq-section">
    <h2>{title}</h2>
    {items.map((item, idx) => (
      <FAQItem key={idx} question={item.q} answer={item.a} />
    ))}
  </div>
);

const FAQ = () => {
  const faqData = [
    {
      title: 'About Orter',
      items: [
        {
          q: "What is Orter?",
          a: "Orter is an anonymous social network where you can connect, chat, and share freely without revealing your identity. It’s built for both individuals and organizations who want to create safe, judgment-free spaces for discussion."
        },
        {
          q: "Who can join Orter?",
          a: "Anyone aged 18 and above can create an account and start connecting. Organizations like schools, churches, and nonprofits can also join to create support groups and private communities."
        },
        {
          q: "Is Orter truly anonymous?",
          a: "Yes. Every user is assigned a unique username. Personal details (like your name or email) are never shown publicly."
        }
      ]
    },
    {
      title: 'Privacy & Security',
      items: [
        {
          q: "How do you protect my identity?",
          a: "We never display personal information, and chats are encrypted. Conversations stay private between users"
        },
        {
          q: "Can my messages be traced back to me?",
          a: "No. Only in cases of extreme violation of our safety policy (e.g., threats or abuse) would Orter investigate with proper legal process."
        },
        {
          q: "How do you handle reports or abuse?",
          a: "Any form of harassment, trolling, or bullying will lead to account suspension. We encourage users to report unsafe behavior immediately."
        }
      ]
    },
    {
      title: 'Usage & Support',
      items: [
        {
          q: "Can I join multiple organizations?",
          a: "Yes. You can join multiple organizations as long as you have access via invite code or a verified domain email (e.g., yourschool.org)."
        },
        {
          q: "Can I rate people I chat with?",
          a: "Yes! After a conversation, you can rate how well the person understood or helped with your topic. This helps others find trusted, experienced peers."
        },
        {
          q: "Is Orter free?",
          a: "Individuals can join for free. Organizations pay a small yearly or monthly fee depending on their member size."
        },
        {
          q: "How can I contact support?",
          a: "Visit our Help Center or use the “Contact Us” form in the app/website to reach our support team."
        }
      ]
    }
  ];

  return (
    <div>
      <Navbar />
        <div className="faq-container">
        <h1>FAQs</h1>
        {faqData.map((section, idx) => (
            <FAQSection key={idx} title={section.title} items={section.items} />
        ))}
        </div>
        <Footer />
    </div>
  );
};

export default FAQ;
